export const SET_MEASURED_DOM = 'setMeasuredDom';
export const CLEAR_MEASURED_DOM = 'clearMeasuredDom';
export const SET_STAGE_LAYOUT = 'setStageLayout';
export const SET_MEASURED_SCROLL = 'setMeasuredScroll';
export const SET_STAGE_RECT = 'setStageRect';
export const SET_PREVIEW_POS = 'setPreviewPos';
export const SET_EDITOR_CONTENT_LAYOUT = 'setEditorContentLayout';
